import { render } from "./countries.vue?vue&type=template&id=847b5196"
import script from "./countries.vue?vue&type=script&lang=js"
export * from "./countries.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__